var fakeWindow = {
  Settings: require('settings'),
  Messages: window.Messages || {},
  location: window.location,
  PENDING_OPERATION_JAVASCRIPT_WAIT: window.PENDING_OPERATION_JAVASCRIPT_WAIT,
  PENDING_OPERATION_JAVASCRIPT_TIMEOUT: window.PENDING_OPERATION_JAVASCRIPT_TIMEOUT
};

module.exports = fakeWindow;
